export default () => {
    return {
        namespaced: true,
        state: {
            items: [],
            ai: 0
        },
        getters: {
            all: state => state.items,
        },
        mutations: {
            add(state, {text, title, type}) {
                state.items.push({id: ++state.ai, text, title, type});
            },
            remove(state, id) {
                state.items = state.items.filter(msg => msg.id !== id);
            }
        },
        actions: {
            add({state, commit}, {text, timeout, title = '', type = 'danger'}) {
                commit('add', {text, title, type});
                let id = state.ai;

                if (timeout !== undefined) {
                    setTimeout(() => {
                        commit('remove', id);
                    }, timeout);
                }
            },
            success({dispatch}, {text, title = 'Успех!', timeout = 3600}) {
                dispatch('add', {text, timeout, title, type: 'success'})
            },
            error({dispatch}, {text, title = 'Ошибка!', timeout = 3600}) {
                dispatch('add', {text, timeout, title, type: 'error'})
            },
            warning({dispatch}, {text, title = 'Предупреждение!', timeout = 3600}) {
                dispatch('add', {text, timeout, title, type: 'warning'})
            },
            info({dispatch}, {text, title = 'Информация!', timeout = 3600}) {
                dispatch('add', {text, timeout, title, type: 'info'})
            },
        }
    }
}